module.exports = __webpack_public_path__ + "img/fx.dc3c45c4.svg";